;(function () {
  'use strict'
  angular
    .module('contrast.application.dashboard')
    .controller('AppSettingsRuleExclusionsCtrl', AppSettingsRuleExclusionsCtrl)

  function AppSettingsRuleExclusionsCtrl(
    $scope,
    $window,
    $routeParams,
    $filter,
    $q,
    $timeout,
    $uibModal,
    $translate,
    dialogs,
    logger,
    csTemplates,
    permissions,
    LoadFilterRouteService,
    ErrorService,
    RuleExclusionService,
    FeaturesService,
    ApplicationFactory,
    ProtectionRulesFactory,
    AGENT_FEATURE
  ) {
    'ngInject'

    var suppressFromExclusionTemplateUrl =
      'views/attacks/modal_suppress_event_app_exclusion.html'
    var deleteExclusionTemplateUrl =
      'views/applications/settings/template/delete.tpl.html'
    var _searchKeywords = '',
      _delay = 300

    var filterFunction = function (exclusion) {
      var val = $scope.data.searchKeywords().toLowerCase()
      return exclusion.name.toLowerCase().indexOf(val || '') !== -1
    }

    angular.extend($scope, {
      appId: $routeParams.appId,
      updating: false,
      data: {
        numPerLoad: 5,
        loadPromise: null,
        busy: true,
        row: 'name',
        exclusions: {
          all: [],
          displayed: [],
          filtered: []
        },
        isEditExclusionModalOpen: false,
        eventForExclusion: null,
        currentExclusionId: null,
        searchKeywords: searchKeywords
      }
    })

    angular.extend($scope, {
      moveToServer: moveToServer,
      loadByScroll: loadByScroll,
      order: order,
      openEdit: openEdit,
      openDelete: openDelete,
      changeDefend: changeDefend,
      changeAssessment: changeAssessment,
      isProtectFeatureEnabled: isProtectFeatureEnabled,
      isAssessFeatureEnabled: isAssessFeatureEnabled,
      addExclusionSuccessCallback: addExclusionSuccessCallback,
      closeEditExclusionModal: closeEditExclusionModal,
      onExclusionEdited: onExclusionEdited
    })

    function init() {
      $scope.$on('application:overview:load', function () {
        _setInformation()
      })

      if ($scope.application) {
        _setInformation()
      }
      _loadServerInformation($scope.appId).then(function () {
        const eventForExclusion = JSON.parse(
          $window.localStorage.getItem('eventForExclusion')
        )

        if (eventForExclusion !== null) {
          $scope.model.eventForExclusion = eventForExclusion
          $window.localStorage.removeItem('eventForExclusion')
        }
      })
    }

    function moveToServer() {
      LoadFilterRouteService.goToServersFilteredByApp($scope.appId)
    }

    function loadByScroll() {
      var displayedCount = $scope.data.exclusions.displayed.length,
        filteredCount = $scope.data.exclusions.filtered.length

      if (displayedCount == filteredCount || filteredCount == 0) {
        return
      }

      loadRuleExclusionsForDisplay(displayedCount + $scope.data.numPerLoad)
    }

    function order(rowName) {
      if ($scope.data.row === rowName) {
        return
      }

      $scope.data.row = rowName
      clearExclusions()
      applyFilters()
      loadRuleExclusionsForDisplay($scope.data.numPerLoad)
    }

    function openEdit(exclusion) {
      $scope.model.isEditExclusionModalOpen = true
      $scope.model.currentExclusionId = exclusion.exception_id
    }

    function closeEditExclusionModal() {
      $scope.model.isEditExclusionModalOpen = false
      $scope.model.currentExclusionId = null
    }

    function onExclusionEdited() {
      loadRuleExclusions($scope.appId)
    }

    function openDelete(exclusion) {
      var transl = {
        detail_unableToLoadRemoveDialog: $translate.instant(
          'detail_unableToLoadRemoveDialog'
        )
      }

      return csTemplates
        .loadAndInterpolate(deleteExclusionTemplateUrl, {
          exclusionName: exclusion.name
        })
        .then(
          function (interpolatedStr) {
            _deleteExclusion(interpolatedStr, exclusion)
          },
          function () {
            logger.logError(transl.detail_unableToLoadRemoveDialog)
          }
        )
    }

    function changeDefend(exclusion) {
      $scope.updating = true

      ProtectionRulesFactory.toggleDefendStatus(
        $scope.appId,
        exclusion.exception_id
      )
        .then(function () {
          $scope.updating = false
          if (exclusion.defend) {
            _openSuppressModal(exclusion.exception_id)
          }
        })
        .catch(function (response) {
          $scope.updating = false
          exclusion.defend = !exclusion.defend
          ErrorService.processError(response)
        })
    }

    function changeAssessment(exclusion) {
      $scope.updating = true
      ApplicationFactory.toggleAssessmentStatus(
        $scope.appId,
        exclusion.exception_id
      )
        .then(function () {
          $scope.updating = false
        })
        .catch(function (response) {
          $scope.updating = false
          exclusion.assessment = !exclusion.assessment
          ErrorService.processError(response)
        })
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }
      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      clearExclusions()
      applyFilters()
      loadRuleExclusionsForDisplay($scope.data.numPerLoad)

      return _searchKeywords
    }

    function _loadServerInformation(appId) {
      return ApplicationFactory.getGeneralServerProtectionSettings(appId, true)
        .then(function (response) {
          $scope.total_assessment = response.data.total_assessment
          $scope.total_protection = response.data.total_protection

          loadRuleExclusions($scope.appId)
        })
        .catch(function (response) {
          $scope.data.busy = false
          ErrorService.processError(response)
        })
    }

    function _setInformation() {
      FeaturesService.isAgentFeatureEnabled(
        AGENT_FEATURE.APP_PROTECT_EXCLUSIONS,
        $scope.application.language
      ).then(function (enabled) {
        $scope.protect_exclusion_feature = enabled
      })

      FeaturesService.isAgentFeatureEnabled(
        AGENT_FEATURE.APP_ASSESS_EXCLUSIONS,
        $scope.application.language
      ).then(function (enabled) {
        $scope.assess_exclusion_feature = enabled
      })
    }

    function loadRuleExclusions(appId) {
      $scope.data.busy = true

      $scope.data.loadPromise = ApplicationFactory.getExclusions(appId)
        .then(function (response) {
          $scope.data.exclusions.all = response.data.exceptions

          _.each(
            $scope.data.exclusions.all,
            RuleExclusionService.addSwitchProperties
          )

          clearExclusions()
          applyFilters()
          loadRuleExclusionsForDisplay($scope.data.numPerLoad)
        })
        .catch(function (response) {
          $scope.data.busy = false
          ErrorService.processError(response)
        })
    }

    function loadRuleExclusionsForDisplay(limit) {
      var displayCount =
        $scope.data.exclusions.filtered.length < limit
          ? $scope.data.exclusions.filtered.length
          : limit
      displayCount = displayCount ? displayCount : 0

      $scope.data.busy = true

      $scope.data.loadPromise = $q(function (resolve) {
        $timeout(function () {
          resolve()
        }, _delay)
      })

      return $scope.data.loadPromise.then(function () {
        $scope.data.exclusions.displayed =
          $scope.data.exclusions.filtered.slice(0, displayCount)

        $scope.data.busy = false

        $timeout(function () {
          $scope.$emit('triggerScrollCheck')
        })
      })
    }

    function clearExclusions() {
      $scope.data.exclusions.displayed = []
      $scope.data.exclusions.filtered = []
    }

    function applyFilters() {
      $scope.data.exclusions.filtered = $filter('filter')(
        $scope.data.exclusions.all,
        filterFunction
      )
      $scope.data.exclusions.filtered = $filter('orderBy')(
        $scope.data.exclusions.filtered,
        $scope.data.row
      )
    }

    function _openSuppressModal(exclusionId) {
      ApplicationFactory.countEventsByExclusion($scope.appId, exclusionId)
        .then(function (response) {
          var totalEvents = response.data.count
          if (totalEvents > 0) {
            //open modal to suppress events
            $uibModal.open({
              templateUrl: suppressFromExclusionTemplateUrl,
              controller: 'SuppressFromExclusionCtrl',
              size: 'md-sm',
              resolve: {
                appId: function () {
                  return $scope.appId
                },
                exclusionId: function () {
                  return exclusionId
                },
                totalEvents: function () {
                  return totalEvents
                }
              }
            })
          }
        })
        .catch(ErrorService.processError)
    }

    function _deleteExclusion(msg, exclusion) {
      var transl = {
        title_applicationExclusion_deleteExclusion: $translate.instant(
          'title_applicationExclusion_deleteExclusion'
        ),
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel')
      }

      return dialogs
        .confirm(transl.title_applicationExclusion_deleteExclusion, msg, {
          size: 'sm',
          yes: transl.action_delete,
          no: transl.action_cancel
        })
        .result.then(function () {
          ApplicationFactory.deleteExclusion(
            $scope.appId,
            exclusion.exception_id
          )
            .then(function (response) {
              logger.logSuccess(response.data.messages[0])
              loadRuleExclusions($scope.appId)
            })
            .catch(ErrorService.processError)
        })
    }

    function isProtectFeatureEnabled() {
      return $scope.protect_exclusion_feature && permissions.isRASPEnabled()
    }

    function isAssessFeatureEnabled() {
      return $scope.assess_exclusion_feature
    }

    function addExclusionSuccessCallback(exclusionId, shouldSuppressEvents) {
      loadRuleExclusions($scope.appId)

      //check if there are events that match the exclusion
      if (isProtectFeatureEnabled() && shouldSuppressEvents) {
        _openSuppressModal(exclusionId)
      }
    }

    init()
  }
})()
